import React from "react";
import { HEADER, PROMISE_LINE } from "./threadFormat";

export default function ThreadHeader() {
  return (
    <div data-slot="thread-header" className="tw-mb-4">
      <h2
        data-slot="thread-title"
        className="tw-m-0 tw-text-2xl tw-font-bold tw-text-text max-rail:tw-text-xl"
      >
        {HEADER}
      </h2>
      <p
        data-slot="thread-promise"
        className="tw-mb-0 tw-mt-1 tw-text-sm tw-text-text-muted"
      >
        {PROMISE_LINE}
      </p>
    </div>
  );
}
